/* eslint-disable react/prop-types */
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
} from '@mui/material';

import styles from '@/features/members/components/department.module.css';
import { Department } from '@/features/companies';

interface DepartmentSelectionSectionProps {
  departments: Department[];
  selectedDepartmentCodes: number[];
  onDepartmentCodesChange: (codes: number[]) => void;
}

export const DepartmentSelectionSection: React.FC<DepartmentSelectionSectionProps> = ({
  departments,
  selectedDepartmentCodes,
  onDepartmentCodesChange,
}) => {
  const selectedSet = new Set(selectedDepartmentCodes);

  const handleToggle =
    (code: number) => (_event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      if (checked) {
        if (!selectedSet.has(code)) {
          onDepartmentCodesChange([...selectedDepartmentCodes, code]);
        }
      } else {
        onDepartmentCodesChange(selectedDepartmentCodes.filter((c) => c !== code));
      }
    };

  return (
    <Box>
      <Typography variant='subtitle1' fontWeight={600} sx={{ mb: 1.5, textAlign: 'left' }}>
        部署
      </Typography>
      <Box className={styles.authoritySection}>
        <FormGroup className={styles.departmentGroup}>
          {departments.map((department) => {
            const departmentCode = department.code || 0;
            return (
              <FormControlLabel
                key={department.id}
                control={
                  <Checkbox
                    checked={selectedSet.has(departmentCode)}
                    onChange={handleToggle(departmentCode)}
                    value={departmentCode.toString()}
                  />
                }
                label={department.name}
              />
            );
          })}
        </FormGroup>
        <FormHelperText className={styles.errorHelperText}></FormHelperText>
      </Box>
    </Box>
  );
};
